import { render, staticRenderFns } from "./OsItemPecas.vue?vue&type=template&id=4ab91640&"
import script from "./OsItemPecas.vue?vue&type=script&lang=js&"
export * from "./OsItemPecas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports